import React, { useMemo } from 'react';
import { Link } from '@americanexpress/one-app-router';
import { Link as DlsLink } from '@americanexpress/dls-react';
import { FormattedMessage } from 'react-intl';
import AnalyticsClick from './analyticsClick';

export function TermsLinks(props) {
  const { cardname, benefitNameTag, localeDetails } = props;
  const pathname = useMemo(() => (cardname ? `/card-benefits/terms/${cardname}` : '/card-benefits/terms'), [cardname]);
  const memoizedBenefitNameTag = useMemo(() => benefitNameTag?.replace(/ /g, '-').toLowerCase(), [benefitNameTag]);
  const memoizedCardName = useMemo(() => cardname?.replace(/ /g, '-').toLowerCase(), [cardname]);

  if (localeDetails !== 'en-US' || !global.BROWSER) {
    return null;
  }

  return (
    <div role="navigation" aria-label="Terms" className="margin-0 flex flex-wrap">
      <AnalyticsClick element={`${memoizedCardName}>>benefit-terms`} benefitNameTag={memoizedBenefitNameTag}>
        <DlsLink asChild={true} isInline={true}>
          <Link data-testid="link-top" to={`${pathname}#top`}>
            <FormattedMessage id="shared.terms-links.benefits-terms" defaultMessage="Benefit Terms" />
          </Link>
        </DlsLink>
      </AnalyticsClick>
      &nbsp;&nbsp;
      <AnalyticsClick element={`${memoizedCardName}>>amex-assurance-disclosures`} benefitNameTag={memoizedBenefitNameTag}>
        <DlsLink asChild={true} isInline={true}>
          <Link data-testid="link-disclosures" to={`${pathname}#disclosures`}>
            <FormattedMessage id="shared.terms-links.disclosures" defaultMessage="Amex Assurance Disclosures" />
          </Link>
        </DlsLink>
      </AnalyticsClick>
    </div>
  );
}
